import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import GamesView from '../views/GamesView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import DashboardView from '../views/DashboardView.vue'
import AdminView from '../views/AdminView.vue'
import BookView from '../views/BookView.vue'
import { useAuthStore } from '../stores/auth'

const routes = [
  { path: '/', component: HomeView }, { path: '/games', component: GamesView }, { path: '/book', component: BookView, meta: { auth: true } },
  { path: '/login', component: LoginView, meta: { guest: true } }, { path: '/register', component: RegisterView, meta: { guest: true } },
  { path: '/account', component: DashboardView, meta: { auth: true } }, { path: '/admin', component: AdminView, meta: { admin: true } },
  { path: '/payment/return', component: DashboardView, meta: { auth: true } }, { path: '/:pathMatch(.*)*', redirect: '/' }
]
const router = createRouter({ history: createWebHistory(), routes, scrollBehavior: () => ({ top: 0 }) })
router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!auth.ready) await auth.load()
  if (to.meta.auth && !auth.isLoggedIn) return { path: '/login', query: { redirect: to.fullPath } }
  if (to.meta.admin && !auth.isAdmin) return auth.isLoggedIn ? '/account' : '/login'
  if (to.meta.guest && auth.isLoggedIn) return auth.isAdmin ? '/admin' : '/account'
})
export default router
